/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Rail_Scan_TitleInputs */

const en_portal_rail_scan_title = /** @type {(inputs: Portal_Rail_Scan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calories from a photo`)
};

const pl_portal_rail_scan_title = /** @type {(inputs: Portal_Rail_Scan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalorie ze zdjęcia`)
};

/**
* | output |
* | --- |
* | "Calories from a photo" |
*
* @param {Portal_Rail_Scan_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_rail_scan_title = /** @type {((inputs?: Portal_Rail_Scan_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Rail_Scan_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_rail_scan_title(inputs)
	return en_portal_rail_scan_title(inputs)
});